export const MARKETING_HOME_PAGE_URL = 'https://cartage.ai'
export const TERMS_OF_USE_URL = 'https://cartage.ai/terms'
export const PRIVACY_POLICY_URL = 'https://cartage.ai/privacy-policy'
